/**
 * Switch/Toggle компонент
 *
 * Использует button вместо label для лучшей совместимости с Shadow DOM
 * и корректной accessibility (role="switch")
 *
 * Примечание: Для позиционирования thumb используется CSS transform вместо
 * Tailwind translate утилит из-за проблемы с @property в Shadow DOM.
 * См. https://github.com/tailwindlabs/tailwindcss/issues/17104
 */
import './switch.css';

export const Switch = ({
  checked = false,
  onChange,
  label,
  disabled = false,
  id,
  className = ''
}) => {
  const handleClick = (e) => {
    if (!disabled && onChange) {
      // Blur the button to prevent iOS from transferring focus to nearby inputs
      // after React re-render (which causes unwanted zoom on mobile)
      e.currentTarget.blur();
      onChange(!checked);
    }
  };

  const handleKeyDown = (e) => {
    // Space и Enter для переключения
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <button
      type="button"
      id={id}
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className={`switch${disabled ? ' switch--disabled' : ''} ${className}`.trim()}
    >
      <div
        className={`switch-track${checked ? ' switch-track--on' : ''}`}
      >
        <div
          className={`switch-thumb ${checked ? 'switch-thumb-on' : 'switch-thumb-off'}`}
        />
      </div>
      {label && (
        <span className="switch__label">{label}</span>
      )}
    </button>
  );
};
